import React from 'react';
import autoBind from 'auto-bind';
import {
  Grid,
  Form,
  Input,
  Dropdown,
  Button,
  Message,
  Icon,
} from 'semantic-ui-react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { format, startOfDay, endOfDay } from 'date-fns';

import DatePicker from 'components/DatePicker';
import {
  changeBusinessFilter,
  closeBusinessDetails,
  setEmployeeActionsPage,
  setEmployeeSlotsPage,
} from 'state/business/actions';

const dateToString = date => (date ? format(date, 'd/M/yyyy') : null);

export class ActionBar extends React.Component {
  constructor(props) {
    super(props);
    this.state = { ...props.filters };
    autoBind(this);
  }

  onStartDateChanged(date) {
    this.setState({
      startDate: date ? startOfDay(date) : null,
    });
  }

  onEndDateChanged(date) {
    this.setState({
      endDate: date ? endOfDay(date) : null,
    });
  }

  onStatusFilterChanged(event, { value }) {
    this.setState({
      status: value,
    });
  }

  onSearchByFilterChanged(event, { value }) {
    this.setState({
      searchBy: value,
    });
  }

  onSearchKeywordChanged(event, { value }) {
    if (value === '') this.onResetSearchField();
    else {
      this.setState({
        searchKeyword: value,
      });
    }
  }

  onInvoiceNumberChanged(event, { value }) {
    this.setState({
      invoiceNumber: value.toUpperCase(),
    });
  }

  onApplyFilter(filters) {
    const { dispatch } = this.props;
    const payload = {
      ...filters,
      page: 1,
      size: 10,
    };
    dispatch(changeBusinessFilter(payload));
    dispatch(closeBusinessDetails());
    dispatch(setEmployeeSlotsPage(1));
    dispatch(setEmployeeActionsPage(1));
  }

  onResetSearchField() {
    this.setState(
      {
        page: 1,
        size: 10,
        searchKeyword: '',
      },
      () => this.onApplyFilter(this.state)
    );
  }

  onResetFilter() {
    this.setState(
      {
        page: 1,
        size: 10,
        startDate: null,
        endDate: null,
        status: 'all',
        searchBy: 'user_email',
        invoiceNumber: '',
      },
      () => this.onApplyFilter(this.state)
    );
  }

  renderCurrentFilterInfo() {
    const {
      filters: {
        startDate,
        endDate,
        status,
        statusOptions,
        searchBy,
        searchByOptions,
        searchKeyword,
        invoiceNumber,
      },
    } = this.props;

    return (
      <Message info>
        <p>
          Showing
          <span> </span>
          <strong>{statusOptions.find(s => s.value === status).text}</strong>
          <span> </span>
          businesses
          {(startDate !== null || endDate !== null) && (
            <span>
              <span> </span>
              expired
              {startDate !== null && (
                <span>
                  <span> </span>
                  from <strong>{dateToString(startDate)}</strong>
                </span>
              )}
              {endDate !== null && (
                <span>
                  <span> </span>
                  until
                  <span> </span>
                  <strong>{dateToString(endDate)}</strong>
                </span>
              )}
            </span>
          )}
          {searchKeyword.trim().length > 0 && (
            <span>
              <span> </span>
              with{' '}
              <strong>
                {searchByOptions.find(s => s.value === searchBy).text}
              </strong>{' '}
              containing <strong>{searchKeyword}</strong>
            </span>
          )}
          {invoiceNumber.trim().length > 0 && (
            <span>
              <span> </span>
              with invoice number <strong>{invoiceNumber}</strong>
            </span>
          )}
        </p>
      </Message>
    );
  }

  render() {
    const {
      startDate,
      endDate,
      status,
      searchBy,
      searchKeyword,
      invoiceNumber,
    } = this.state;
    const {
      filters: { statusOptions, searchByOptions },
      isLoading,
    } = this.props;
    return (
      <div>
        <Form>
          <Grid>
            <Grid.Column width="4">
              <label htmlFor="status-filter">Payment Status</label>
              <Dropdown
                id="status-filter"
                options={statusOptions}
                fluid
                selection
                value={status}
                onChange={this.onStatusFilterChanged}
              />
            </Grid.Column>
            <Grid.Column width="4">
              <label htmlFor="start-created-date">Expiration date from</label>
              <DatePicker
                id="start-created-date"
                onChange={this.onStartDateChanged}
                selected={startDate}
                isClearable
              />
            </Grid.Column>
            <Grid.Column width="4">
              <label htmlFor="end-created-date">to</label>
              <DatePicker
                id="end-created-date"
                onChange={this.onEndDateChanged}
                selected={endDate}
                isClearable
              />
            </Grid.Column>
            <Grid.Column width="4">
              {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
              <label style={{ margin: '100%' }}>
                <span>&nbsp;</span>
              </label>
              <Button
                primary
                onClick={() => this.onApplyFilter(this.state)}
                loading={isLoading}
                disabled={isLoading}
              >
                Search
              </Button>
              <Button
                primary
                basic
                onClick={this.onResetFilter}
                loading={isLoading}
                disabled={isLoading}
              >
                Reset Filter
              </Button>
            </Grid.Column>
          </Grid>
        </Form>
        <br />
        <Grid>
          <Grid.Column width="12">
            <Input
              placeholder="Search keyword..."
              label={
                <Dropdown
                  id="search-by-filter"
                  options={searchByOptions}
                  selection
                  compact
                  value={searchBy}
                  onChange={this.onSearchByFilterChanged}
                  style={{ 'font-weight': 'normal' }}
                />
              }
              icon={
                // eslint-disable-next-line react/destructuring-assignment
                this.state.searchKeyword !== '' && (
                  <Icon name="delete" link onClick={this.onResetSearchField} />
                )
              }
              onKeyPress={e =>
                e.charCode === 13 ? this.onApplyFilter(this.state) : null
              }
              onChange={this.onSearchKeywordChanged}
              value={searchKeyword}
              fluid
            />
          </Grid.Column>
          <Grid.Column width="4">
            <Input
              placeholder="Input Invoice Number"
              onChange={this.onInvoiceNumberChanged}
              value={invoiceNumber}
              fluid
            />
          </Grid.Column>
        </Grid>
        {this.renderCurrentFilterInfo()}
        <br />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  filters: state.business.filters,
});

ActionBar.propTypes = {
  dispatch: PropTypes.func.isRequired,
  filters: PropTypes.shape({
    startDate: PropTypes.instanceOf(Date),
    endDate: PropTypes.instanceOf(Date),
    status: PropTypes.string,
    statusOptions: PropTypes.arrayOf(
      PropTypes.shape({
        key: PropTypes.string.isRequired,
        value: PropTypes.string.isRequired,
        text: PropTypes.string.isRequired,
      })
    ),
    searchBy: PropTypes.string,
    searchByOptions: PropTypes.arrayOf(
      PropTypes.shape({
        key: PropTypes.string.isRequired,
        value: PropTypes.string.isRequired,
        text: PropTypes.string.isRequired,
      })
    ),
    searchKeyword: PropTypes.string.isRequired,
    invoiceNumber: PropTypes.string.isRequired,
  }).isRequired,
  isLoading: PropTypes.bool.isRequired,
};

export default connect(mapStateToProps)(ActionBar);
